import { getCookie, setCookie } from '@/shared/lib/helpers/cookies';
import { yaCounterByHostname } from '@/shared/lib/helpers/yandexCounter';

export default function checkPwaOpened(checkPlace) {
	if (window.matchMedia('(display-mode: standalone)').matches) {
		console.log(`PWA: ${checkPlace}, цель "открытие приложения" игнорируется`);
		if (!getCookie('use_pwa')) {
			const expires = new Date(Date.now() + 1 * 3600 * 1000).toUTCString();
			setCookie('use_pwa', 'ignoreYM', { expires });
			window.ym(yaCounterByHostname(), 'reachGoal', 'use_pwa');
			console.log('отправка use_pwa в куки на час, цель "открытие приложения" достигнута');
		}
	} else {
		console.log('не пва');
	}
}
